// extracted by mini-css-extract-plugin
export default {"component":"Step__component-j5ja","content":"Step__content-MWUe"};